// src/redux/authSlice.js - Actualizado con tokenSII
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tokenSII: '',
  isAuthenticated: false
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setTokenSII: (state, action) => {
      state.tokenSII = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    clearTokenSII: (state) => {
      state.tokenSII = '';
      state.isAuthenticated = false;
    }
  }
});

export const { setTokenSII, clearTokenSII } = authSlice.actions;
export default authSlice.reducer;